import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const SortUpFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M12.48 9.92L11.4 8.88L16.68 3.6L21.96 8.88L20.88 9.92L17.56 6.52V19H15.8V6.52L12.48 9.92ZM4.52 5.3H8.48V7.3H4.52V5.3ZM4.52 11.04H10.48V12.88H4.52V11.04ZM4.52 16.7H13.48V18.54H4.52V16.7Z" />
    </SvgIcon>
  );
});
